
(function () {
  'use strict';

  // The section may include this file once per placement. Only define once.
  if (window.__tgCustomSlideshowReady) return;
  window.__tgCustomSlideshowReady = true;

  function initCustomSlideshow(sectionEl) {
    if (!sectionEl) return;

    var slideshowEl = sectionEl.querySelector('.custom-slideshow');
    var trackEl = sectionEl.querySelector('.custom-slideshow__track');
    var viewportEl = sectionEl.querySelector('.custom-slideshow__viewport');
    var slides = Array.prototype.slice.call(sectionEl.querySelectorAll('.custom-slideshow__slide'));
    var dots = Array.prototype.slice.call(sectionEl.querySelectorAll('.custom-slideshow__dot'));
    var prevArrow = sectionEl.querySelector('.custom-slideshow__arrow--prev');
    var nextArrow = sectionEl.querySelector('.custom-slideshow__arrow--next');

    if (!slideshowEl || !trackEl || !viewportEl || !slides.length) return;

    // Prevent double init
    if (slideshowEl.dataset.customSlideshowInitialized === 'true') return;
    slideshowEl.dataset.customSlideshowInitialized = 'true';

    var autoplay = slideshowEl.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(slideshowEl.getAttribute('data-autoplay-interval'), 10) || 0;
    var timer = null;
    var currentIndex = 0;

    function pauseAllVideosExcept(exceptVideo) {
      var videos = sectionEl.querySelectorAll('video.custom-slideshow__video');
      Array.prototype.forEach.call(videos, function (video) {
        if (video !== exceptVideo) video.pause();

        var slideEl = video.closest('.custom-slideshow__slide');
        if (!slideEl) return;
        var toggle = slideEl.querySelector('.custom-slideshow__video-toggle');
        if (!toggle) return;

        if (video === exceptVideo && !video.paused) {
          toggle.classList.add('is-playing');
        } else {
          toggle.classList.remove('is-playing');
        }
      });
    }

    function handleActiveSlideVideo() {
      var activeSlide = slides[currentIndex];
      if (!activeSlide) return;

      var video = activeSlide.querySelector('video.custom-slideshow__video');
      if (!video) {
        pauseAllVideosExcept(null);
        return;
      }

      var autoplayAttr = activeSlide.getAttribute('data-video-autoplay');
      var shouldAutoplay = autoplayAttr === 'true' || autoplayAttr === '1';

      if (shouldAutoplay) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }

      pauseAllVideosExcept(video);
    }

    function updateActive() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });

      if (prevArrow) prevArrow.classList.toggle('is-disabled', currentIndex === 0);
      if (nextArrow) nextArrow.classList.toggle('is-disabled', currentIndex === slides.length - 1);

      handleActiveSlideVideo();
    }

    function goTo(index, animate) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      currentIndex = index;

      var slide = slides[currentIndex];
      if (!slide) return;

      var offset = slide.offsetLeft;

      trackEl.style.transition = animate ? 'transform 0.45s ease' : 'none';
      trackEl.style.transform = 'translateX(' + -offset + 'px)';

      updateActive();
    }

    function next(isAuto) {
      var target = currentIndex + 1;
      if (target >= slides.length) {
        target = isAuto ? 0 : slides.length - 1;
      }
      goTo(target, true);
    }

    function prev() {
      var target = currentIndex - 1;
      if (target < 0) target = 0;
      goTo(target, true);
    }

    function autoplayStart() {
      if (!autoplay || interval <= 0 || slides.length <= 1) return;
      autoplayStop();
      timer = setInterval(function () { next(true); }, interval);
    }

    function autoplayStop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Init
    goTo(0, false);

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        autoplayStop();
        goTo(index, true);
        autoplayStart();
      });
    });

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        autoplayStop();
        prev();
        autoplayStart();
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        autoplayStop();
        next(false);
        autoplayStart();
      });
    }

    // Video play/pause toggles (Shopify-hosted video only)
    var toggleButtons = sectionEl.querySelectorAll('[data-video-toggle]');
    Array.prototype.forEach.call(toggleButtons, function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var slideEl = btn.closest('.custom-slideshow__slide');
        if (!slideEl) return;
        var videoEl = slideEl.querySelector('video.custom-slideshow__video');
        if (!videoEl) return;

        if (videoEl.paused) {
          videoEl.play().then(function () {
            pauseAllVideosExcept(videoEl);
            btn.classList.add('is-playing');
          }).catch(function () {});
        } else {
          videoEl.pause();
          btn.classList.remove('is-playing');
        }
      });
    });

    // Touch swipe (mobile)
    var touchStartX = 0;
    var touchStartY = 0;
    var lastTouchX = 0;
    var dragging = false;
    var startTransformX = 0;
    var isScrolling = null;

    function onTouchStart(e) {
      if (!e.touches || e.touches.length > 1) return;

      goTo(currentIndex, false);

      dragging = true;
      isScrolling = null;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      lastTouchX = touchStartX;

      var currentSlide = slides[currentIndex];
      startTransformX = currentSlide ? -currentSlide.offsetLeft : 0;

      trackEl.style.transition = 'none';
      autoplayStop();
    }

    function onTouchMove(e) {
      if (!dragging || !e.touches || !e.touches.length) return;
      var touch = e.touches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;

      if (isScrolling === null) {
        isScrolling = Math.abs(dy) > Math.abs(dx);
      }
      if (isScrolling) return;

      // horizontal swipe: stop the page scrolling underneath
      e.preventDefault();

      lastTouchX = touch.clientX;
      trackEl.style.transform = 'translateX(' + (startTransformX + dx) + 'px)';
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging = false;

      if (isScrolling) {
        isScrolling = null;
        autoplayStart();
        return;
      }

      var dx = lastTouchX - touchStartX;
      var slideWidth = slides[0] ? slides[0].offsetWidth : 100;
      var threshold = slideWidth * 0.2;

      if (Math.abs(dx) > threshold) {
        if (dx < 0) { next(false); } else { prev(); }
      } else {
        goTo(currentIndex, true);
      }

      autoplayStart();
    }

    viewportEl.addEventListener('touchstart', onTouchStart, { passive: false });
    viewportEl.addEventListener('touchmove', onTouchMove, { passive: false });
    viewportEl.addEventListener('touchend', onTouchEnd, { passive: true });
    viewportEl.addEventListener('touchcancel', onTouchEnd, { passive: true });

    autoplayStart();

    // Pause on hover (desktop)
    slideshowEl.addEventListener('mouseenter', autoplayStop);
    slideshowEl.addEventListener('mouseleave', autoplayStart);

    // Recalculate on resize — debounced.
    // goTo() reads offsetLeft then writes transform, so running it on every
    // resize event forces a layout on each one. PageSpeed flagged this as a
    // forced reflow. 150 ms is below the threshold anyone notices.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(currentIndex, false); }, 150);
    }, { passive: true });
  }

  function initAll() {
    var sections = document.querySelectorAll('.custom-slideshow-section');
    Array.prototype.forEach.call(sections, initCustomSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Theme editor: re-init whichever section was just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (!id) return;
    initCustomSlideshow(document.getElementById('section-' + id));
  });
})();